<template>

  <div>
    <el-card class="card-base card-shadow--medium info bg-white black-text">
      <h2>Overview</h2>
      <el-alert
          v-if="statsError"
          :title="statsError"
          type="error"
          :closable="false"
          show-icon
          style="margin-bottom: 20px;">
        <template slot="default">
          <p>Unable to load statistics. Please check if Laravel Horizon is running.</p>
        </template>
      </el-alert>
      <el-row :gutter="20">
        <el-col :span="6">JOBS PER MINUTE: <div class="grid-content bg-purple">{{stats.jobsPerMinute || '-'}}</div></el-col>
        <el-col :span="6">JOBS PAST HOUR: <div class="grid-content bg-purple">{{stats.recentJobs || '-'}}</div></el-col>
        <el-col :span="6">FAILED JOBS PAST HOUR: <div class="grid-content bg-purple">{{stats.recentlyFailed || '-'}}</div></el-col>
        <el-col :span="6">STATUS: <div class="grid-content bg-purple">{{stats.status || '-'}}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">TOTAL PROCESSES: <div class="grid-content bg-purple">{{stats.processes || '-'}}</div></el-col>
        <el-col :span="6">MAX WAIT TIME: <div class="grid-content bg-purple">-</div></el-col>
        <el-col :span="6">MAX RUNTIME: <div class="grid-content bg-purple">{{stats.queueWithMaxRuntime || '-'}}</div></el-col>
        <el-col :span="6">MAX THROUGHPUT: <div class="grid-content bg-purple">{{stats.queueWithMaxThroughput || '-'}}</div></el-col>
      </el-row>
    </el-card>
    <el-card class="card-base card-shadow--medium info bg-white black-text">
      <h2>Current Workload</h2>
      <el-alert
          v-if="workloadError"
          :title="workloadError"
          type="error"
          :closable="false"
          show-icon
          style="margin-bottom: 20px;">
        <template slot="default">
          <p>Unable to load workload data. Please check if Laravel Horizon is running.</p>
        </template>
      </el-alert>
      <el-table :data="workload" style="width: 100%; min-width:500px;" v-if="!workloadError && workload && Array.isArray(workload) && workload.length > 0">
        <el-table-column prop="name">
          <template slot="header" slot-scope="scope">
            <span>Queue</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column prop="processes">
          <template slot="header" slot-scope="scope">
            <span>Processes</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.processes }}
          </template>
        </el-table-column>
        <el-table-column prop="jobs">
          <template slot="header" slot-scope="scope">
            <span>Jobs</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.length }}
          </template>
        </el-table-column>
        <el-table-column prop="wait">
          <template slot="header" slot-scope="scope">
            <span>Wait</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.wait }}
          </template>
        </el-table-column>
      </el-table>

    </el-card>
    <el-alert
        v-if="mastersError && (!masters || Object.keys(masters).length === 0)"
        :title="mastersError"
        type="error"
        :closable="false"
        show-icon
        style="margin-bottom: 20px;">
      <template slot="default">
        <p>Unable to load masters data. Please check if Laravel Horizon is running.</p>
      </template>
    </el-alert>
    <el-card v-for="(item, index) in (masters || {})" class="card-base card-shadow--medium info bg-white black-text" :key="index" v-if="masters && Object.keys(masters).length > 0">
      <h2>{{ index }}</h2>

      <el-table :data="item.supervisors" style="width: 100%; min-width:500px;">
        <el-table-column prop="name">
          <template slot="header" slot-scope="scope">
            <span>Supervisor</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column prop="name">
          <template slot="header" slot-scope="scope">
            <span>Process</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.options.maxProcesses }}
          </template>
        </el-table-column>
        <el-table-column prop="name">
          <template slot="header" slot-scope="scope">
            <span>Queue</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.options.queue }}
          </template>
        </el-table-column>
        <el-table-column prop="balance">
          <template slot="header" slot-scope="scope">
            <span>Balancing</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.options.balance }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>

</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";

export default {
  name: "Stats",
  computed: {
    ...mapGetters({
      stats: 'monitor/getStats',
      workload: 'monitor/getWorkload',
      masters: 'monitor/getMasters',
      statsError: 'monitor/getStatsError',
      workloadError: 'monitor/getWorkloadError',
      mastersError: 'monitor/getMastersError',
    })
  },
  data(){
    return {
      timer: ''
    }
  },
  mounted () {
    this.loadMonitor();
    this.timer = setInterval(this.loadMonitor, 3000);
  },

  methods: {
    loadMonitor(){
      this.$store.dispatch('monitor/getStats')
      this.$store.dispatch('monitor/getWorkload')
      this.$store.dispatch('monitor/getMasters')
      console.log('her');
    },
    cancelAutoUpdate () {
      clearInterval(this.timer);
    },
  },
  beforeDestroy () {
    this.cancelAutoUpdate();
  }
}
</script>

<style >
.el-row {
  margin-bottom: 20px;

}
.el-row:last-child {
  margin-bottom: 0;
}

.el-col {
  border-radius: 5px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 5px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>